import React, { useEffect, useState } from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardOverviewCalendar from '@components/pages/Dashboard/Overview/DashboardOverviewCalendar.component'
import Button from '@components/common/Button/Button.component'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'

type CalendarCardProps = {
  date: string
  onDateChange: (dateString: string) => void
}

export function CalendarCard({
  date,
  onDateChange,
}: CalendarCardProps): React.ReactElement {
  const [calendarViewMonth, setCalendarViewMonth] = useState<Date>(() => {
    const today = new Date()
    return new Date(today.getFullYear(), today.getMonth(), 1)
  })
  const loading = false
  const hasPayload = true
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasPayload)
  const pending = isDashboardSectionPending(loading, hasPayload)

  useEffect(() => {
    const parsed = new Date(date)
    if (!Number.isNaN(parsed.getTime())) {
      setCalendarViewMonth(new Date(parsed.getFullYear(), parsed.getMonth(), 1))
    }
  }, [date])

  return (
    <DashboardSectionCard
      title="Calendar"
      loading={pending}
      skeleton={{ block: 'none' }}
      isEmpty={isEmpty}
      headerRight={
        <>
          <Button
            type="button"
            className="button-secondary button-sm"
            onClick={() => {
              const today = new Date()
              setCalendarViewMonth(
                new Date(today.getFullYear(), today.getMonth(), 1),
              )
              const year = today.getFullYear()
              const month = String(today.getMonth() + 1).padStart(2, '0')
              const day = String(today.getDate()).padStart(2, '0')
              onDateChange(`${year}-${month}-${day}`)
            }}
          >
            Today
          </Button>
          <span
            role="button"
            className="ti ti-chevron-left"
            onClick={() =>
              setCalendarViewMonth(
                (month) =>
                  new Date(month.getFullYear(), month.getMonth() - 1, 1),
              )
            }
            aria-label="Previous month"
          />
          <span
            role="button"
            className="ti ti-chevron-right"
            onClick={() =>
              setCalendarViewMonth(
                (month) =>
                  new Date(month.getFullYear(), month.getMonth() + 1, 1),
              )
            }
            aria-label="Next month"
          />
        </>
      }
    >
      <DashboardOverviewCalendar
        viewMonth={calendarViewMonth}
        onDateClick={onDateChange}
      />
    </DashboardSectionCard>
  )
}
